import styled from 'styled-components';

export const TaskList = styled.ul`
  margin-top: 0;
  padding: 0;
  max-height: 80vh;
  overflow-y: auto;
`;
